import { Component, Input } from '@angular/core';
import { ToastPosition, ToastComponent } from '../toast/toast.component';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    imports: [ToastComponent],
})
export class NotificationsComponent {
	@Input() position: ToastPosition = 'top-center';
}
